// extracted by mini-css-extract-plugin
export var addressFields = "_qn-0";
export var animationContainer = "_qn-1";
export var footer = "_qn-2";
export var lineItems = "_qn-3";
export var modalContent = "_qn-4";
export var orderName = "_qn-5";
export var strong = "_qn-6";
export var warning = "_qn-7";